import {
  GeckoBinnedDataBuffer,
  serializeBinnedDataBuffer,
} from 'features/dataLayers/geckoBinnedDataBuffer'

import {
  CategoricalSummaryStatistics,
  deserializeCategoricalSummaryStats,
  RawCategoricalSummaryStatistics,
} from './categoricalStatisticsDataType'
import CategoricalDataStatsWorker from './generateCategoricalDataStats.worker?worker'

/**
 * A function that generates the summary statistics of categorical data in a web worker
 */
export function generateCategoricalDataStatsInWorker(
  binnedDataBuffer: GeckoBinnedDataBuffer
): Promise<CategoricalSummaryStatistics | undefined> {
  return new Promise<CategoricalSummaryStatistics | undefined>(
    (resolve, reject) => {
      try {
        const worker = new CategoricalDataStatsWorker()

        const timeoutId = setTimeout(() => {
          worker.terminate()
          reject(
            new Error(
              'Worker timeout: generateCategoricalDataStatsInWorker took too long'
            )
          )
        }, 8000)

        worker.onmessage = async (
          message: MessageEvent<RawCategoricalSummaryStatistics | undefined>
        ) => {
          clearTimeout(timeoutId)
          worker.terminate()
          const ret = !message.data
            ? undefined
            : deserializeCategoricalSummaryStats(message.data)
          resolve(ret)
        }
        worker.onerror = async (error) => {
          clearTimeout(timeoutId)
          console.error('Worker error:', error)
          worker.terminate()
          reject(`Couldn't generate CDF statistics, ${error}`)
        }

        worker.postMessage(serializeBinnedDataBuffer(binnedDataBuffer))
      } catch (error) {
        reject(`Couldn't generate CDF statistics, ${error}`)
        console.error(error)
      }
    }
  )
}
